var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 136,
    viewBox: "0 0 186 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3191 119.183V71H0V135H38.2906V119.183H16.3191Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.793 71V103.183L83.2742 71H70.6019V135H86.9209V102.817L109.439 135H122.021V71H105.793Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185 135L163.849 102.086L184.088 71H165.855L148.442 97.88V71H132.123V135H148.442V106.383L166.766 135H185Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9011 28.2674C46.9321 26.9223 49.3676 26.1389 51.9861 26.1389C59.0814 26.1389 64.8333 31.8908 64.8333 38.9861C64.8333 46.0814 59.0814 51.8333 51.9861 51.8333C44.8908 51.8333 39.1389 46.0814 39.1389 38.9861C39.1389 36.3676 39.9223 33.9321 41.2674 31.9011L37.5808 28.2146C35.332 31.2172 34 34.9461 34 38.9861C34 48.9196 42.0527 56.9722 51.9861 56.9722C61.9196 56.9722 69.9722 48.9196 69.9722 38.9861C69.9722 29.0527 61.9196 21 51.9861 21C47.9461 21 44.2172 22.332 41.2146 24.5808L44.9011 28.2674Z",
    fill: "url(#paint0_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.417 38.5417C28.417 25.7701 38.7704 15.4167 51.542 15.4167C57.7411 15.4167 63.3705 17.8559 67.5227 21.827L71.4402 18.4691C66.3325 13.4055 59.3025 10.2778 51.542 10.2778C35.9322 10.2778 23.2781 22.932 23.2781 38.5417C23.2781 54.1514 35.9322 66.8056 51.542 66.8056C67.1517 66.8056 79.8058 54.1514 79.8058 38.5417C79.8058 32.5417 77.9362 26.9783 74.7478 22.4024L70.8216 25.7676C73.2515 29.4276 74.667 33.8194 74.667 38.5417C74.667 51.3133 64.3135 61.6667 51.542 61.6667C38.7704 61.6667 28.417 51.3133 28.417 38.5417Z",
    fill: "url(#paint1_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9946 30.9965C18.4348 33.4212 18.1389 35.9469 18.1389 38.5417C18.1389 56.9895 33.0938 71.9444 51.5417 71.9444C58.5858 71.9444 65.1207 69.764 70.5081 66.0412L73.7255 70.0629C67.4526 74.4857 59.8005 77.0833 51.5417 77.0833C30.2557 77.0833 13 59.8276 13 38.5417C13 35.3523 13.3874 32.2534 14.1177 29.2895L18.9946 30.9965ZM20.5363 26.0915C25.4726 13.8099 37.4945 5.13889 51.5417 5.13889C69.9895 5.13889 84.9444 20.0938 84.9444 38.5417C84.9444 48.0974 80.9319 56.716 74.4997 62.8044L77.7196 66.8293C85.3234 59.7892 90.0833 49.7213 90.0833 38.5417C90.0833 17.2557 72.8276 0 51.5417 0C35.2512 0 21.3214 10.1067 15.6803 24.3919L20.5363 26.0915Z",
    fill: "url(#paint2_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 135V49.0469C45.3231 50.0082 46.8045 50.7299 48.377 51.1792L49.5 51.5L49.7151 51.543C51.2258 51.8452 52.7788 51.8702 54.2985 51.6169C54.7654 51.5391 55.2256 51.4248 55.6747 51.2751L55.7962 51.2346C57.2564 50.7479 58.6312 50.0352 59.8706 49.1226L60 49.0273V135H44Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 39C60 43.4183 56.4183 47 52 47C47.5817 47 44 43.4183 44 39C44 34.5817 47.5817 31 52 31C56.4183 31 60 34.5817 60 39Z",
    fill: "#E71D38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9861 38.9861) rotate(90) scale(17.9861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E25241",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25241",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.542 38.5417) rotate(90) scale(28.2639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25241",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5417 38.5417) rotate(-180) scale(38.5417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25241",
    stopOpacity: 0.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.f8841949.svg";
export { ForwardRef as ReactComponent };